import ParentalConsentRouter from './Router'

export { ParentalConsentRouter }
